<div style="display: block; padding-top: 20px">
  <div style="text-align: center">
    <p>Ratio de tramitaciones</p>
  </div>
  <canvas baseChart
          [data]="doughnutChartData"
          [labels]="doughnutChartLabels"
          [chartType]="doughnutChartType"
          (chartHover)="chartHovered($event)"
          (chartClick)="chartClicked($event)"
          [colors]="colors">

  </canvas>

</div>
